export const ACCOMMODATION = '/accommodation/' as const
export const ACCOMMODATION_STUDENT_INFO = `${ACCOMMODATION}student-info` as const
export const ACCOMMODATION_CHANGE_STATUS = `${ACCOMMODATION}change-status` as const
